import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { ExpressionValue } from "../../ExpressionValue";
import { BaseStringExpression } from "./BaseString";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class StringCombineExpression extends BaseStringExpression {
    readonly __type: string = "String Combine";
    readonly __ruleName: string = "Combine";
    value1: ExpressionValue;
    value2: ExpressionValue;

    constructor() {
        super();

        this.expressionValueType = new StringDataDefinition();
        this.value1 = ExpressionValue.createExpressionValue(this, "value1", new StringDataDefinition());
        this.value2 = ExpressionValue.createExpressionValue(this, "value2", new StringDataDefinition());
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return `${this.value1.evaluate(data, testContext)}${this.value2.evaluate(data, testContext)}`;
    }
}
